<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">تعديل رصيد العميل</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/payments">المدفوعات</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">تعديل رصيد العميل</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="card card-secondary card-outline mb-4 mt-4">
              <!--begin::Header-->
              <div class="card-header"><div class="card-title">تعديل رصيد العميل</div></div>
              <!--end::Header-->
              <!--begin::Form-->
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <successAlert v-if="hasSucess" :message="message" />

              <form @submit.prevent="subimtData()">
                <!--begin::Body-->
                <div class="card-body">
                  <div class="row">
                    <div class="col">
                      <div class="alert alert-warning">انتبه: يرجى تحري الدقة حيث ان هذا الإجراء لا يمكن التراجع عنه</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label" for="">العميل:</label>
                      <input type="text" class="form-control" placeholder="جوال العميل" @keyup="getClientData()" v-model="userMobile">
                    </div>
                    <div class="col-12 col-sm-6 mb-3">
                      <loader v-if="userLoader" />
                      <div v-if="userName">
                        <label class="form-label" for="">اسم العميل:</label>
                        <div>{{ userName }}</div>
                        <div>الرصيد الحالي: {{ userBalance }} ريال</div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label for="" class="form-label">وصف عربي: <span class="req">*</span></label>
                      <input type="text" class="form-control" v-model="description">
                    </div>
                    <div class="col-12 col-sm-6 mb-3">
                      <label for="" class="form-label">الوصف انجليزي: <span class="req">*</span></label>
                      <input type="text" class="form-control english-input" v-model="descriptionEn">
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label for="" class="form-label">القيمة: <span class="req">*</span></label>
                      <input type="number" class="form-control" v-model="amount">
                    </div>
                    <div class="col-12 col-sm-6 mb-3">
                      <label for="" class="form-label">نوع العملية: <span class="req">*</span></label>
                      <select v-model="transactionType" class="form-control">
                        <option :value="null">اختر العملية</option>
                        <option value="plus">إضافة رصيد</option>
                        <option value="minus">خصم رصيد</option>
                      </select>
                    </div>
                  </div>
                </div>
                <!--end::Body-->
                <!--begin::Footer-->
                <div class="card-footer">
                  <div class="row">
                    <div class="col text-end">
                      <button v-if="!formLoader" type="submit" class="btn btn-success">ارسل</button>
                      <loader v-if="formLoader" />
                    </div>
                  </div>
                </div>
                <!--end::Footer-->
              </form>
              <!--end::Form-->
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { toast } from '@/helpers/tools';

export default {
  name: 'PaymentCreate',
  data() {
    return {
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      formLoader: false,
      userLoader: false,
      userMobile: null,
      userName: null,
      userBalance: 0,
      // for form 
      userId: null,
      description: null,
      descriptionEn: null,
      amount: 0,
      transactionType: null,
    };
  },
  methods: {
    subimtData(){
      if(!this.userId || !this.transactionType || !this.amount || !this.description || !this.descriptionEn){
        this.message = 'كل البيانات مطلوبة';
        this.errorNumber = 0;
        this.hasError = true;
        this.formLoader = false;
        window.scroll(0,0);
        return;
      }

      const payload = {
        userId: this.userId,
        description: this.description,
        descriptionEn: this.descriptionEn,
        amount: this.amount,
        transactionType: this.transactionType,
      }

      this.$http.post('/api/admin/payments/create', payload).then(({data}) => {
        toast('تم إضافة الإعلان بنجاح', 'success');
        this.$router.replace(`/payments?page=1`).catch(() => {});
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
    getClientData(){
      if(this.userMobile && this.userMobile.length >= 10){
        this.hasError = false;
        this.hasSucess = false;
        this.userLoader = true;
        this.userId = null;
        this.userName = null;
        this.$http.post('/api/admin/users/getUser', {
          mobile: this.userMobile.trim(),
        }).then(({data}) => {
          this.userId = data.user.id;
          this.userName = data.user.name;
          this.userBalance = data.user.balance;
          this.userLoader = false;
        }).catch(err => {
          [this.message, this.errorNumber] = this.$globalError(err, true);
          this.hasError = true;
          this.userLoader = false;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
    },
  },
  created() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
}
</script>
